export default "__VITE_ASSET__LQrZpTZ4__"